/**
 * AuthModule => share AuthService
 */


// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
// Used Modules
// Auth Services
import { AuthService } from './auth.service';
import { AuthRedirectModule } from "libraries/service/auth-redirect/auth-redirect.module";
import { OsmanCompanyResourceModule } from '../resources/osman/osman-company-resource.module';
import { SamResourceModule } from '../resources/sam/samResource.module';
import { UserAuthModule } from '../user-auth/user-auth.module';
import { InstanceService } from '../instance/instance.service';

@NgModule({
    imports: [
        CommonModule,
        AuthRedirectModule,
        OsmanCompanyResourceModule,
        SamResourceModule,
        UserAuthModule,
    ],
    providers: [
        AuthService,
        InstanceService,
    ]
})
export class AuthModule {
}
